<template>
  <div class="card mb-3">
    <div class="card-body">
      {{ team.name }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    team: {
      type: Object,
      required: true
    },
    canManage: {
      type: Boolean,
      default: false
    }
  }
}
</script>
